import { useGetTreatmentModalitiesEnumQuery } from '~/store/services/enumerations';
import { TreatmentAttributeEnum } from '~/lib/types/treatmentAttributes/treatmentAttributes';

export const usePhaseStageCodesForModality = (
  modalityCode?: string,
  treatmentFormCode?: string,
): { isLoading: boolean; phaseStages: TreatmentAttributeEnum[] } => {
  const phaseStages: TreatmentAttributeEnum[] = [];
  const {
    data: treatmentModalities,
    isLoading: isGetTreatmentModalitiesLoading,
  } = useGetTreatmentModalitiesEnumQuery();

  if (!modalityCode) return { isLoading: false, phaseStages: [] };

  if (treatmentModalities) {
    const modality = treatmentModalities.find(
      (modality) => modality.code === modalityCode,
    );
    if (modality) {
      if (modality.treatmentForms.length > 0 && treatmentFormCode) {
        const treatmentForm = modality.treatmentForms.find(
          (form) => form.code === treatmentFormCode,
        );
        if (treatmentForm) {
          phaseStages.push(...treatmentForm.treatmentPhaseStages);
        }
      } else {
        phaseStages.push(...modality.phaseStages);
      }
    }
  }

  return { isLoading: isGetTreatmentModalitiesLoading, phaseStages };
};
